import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const AudienceLink = lazyWithSuspense(async () => import('./AudienceLinkScreen'), {
  loadingState: <LoadingState />,
  exportKey: 'AudienceLinkScreen',
});
